import React, { useState } from 'react'
import Helmet from 'react-helmet'
import { Link, withRouter } from 'react-router-dom'

import FAIcon from '../components/FAIcon'
import SmartLibraryReviewModal from '../components/library/SmartLibraryReviewModal'
import { CAPABILITIES, Permissions } from '../utils/Permissions'

import './Library.scss'

export default withRouter(({ history, user }) => {
  const [showSmartReview, setShowSmartReview] = useState(false)
  const canManageCaseTypes = Permissions.can(user, CAPABILITIES.MANAGE_CASE_TYPES)

  return (
    <div className="library-page-container mt-4">
      <Helmet title="Library" />

      <button
        type="button"
        className="shadow library-card bg-primary text-white border-0 text-left w-100"
        style={{ cursor: 'pointer' }}
        onClick={() => setShowSmartReview(true)}
      >
        <span style={{ fontSize: '1.8rem' }} className="d-inline-block align-middle mr-2">
          ✨
        </span>
        <h5 className="mb-0 pl-2 d-inline-block align-middle text-white font-weight-bold">AI Smart Library Review</h5>
      </button>
      <Link className="shadow library-card bg-white" to="/library/team-members">
        <FAIcon name="user-friends" type="fas" className="library-card-icon d-inline-block align-middle text-primary" />
        <h5 className="mb-0 pl-3 d-inline-block align-middle">Team</h5>
      </Link>

      <Link className="shadow library-card bg-white" to="/library/activities-and-expenses">
        <FAIcon name="user-friends" type="fas" className="library-card-icon d-inline-block align-middle text-primary" />
        <h5 className="mb-0 pl-3 d-inline-block align-middle">Activities and Expenses</h5>
      </Link>

      <Link className="shadow library-card bg-white" to="/library/treatment-providers">
        <FAIcon name="user-md" type="fas" className="library-card-icon d-inline-block align-middle text-primary" />
        <h5 className="mb-0 pl-3 d-inline-block align-middle">Treatment Providers</h5>
      </Link>

      <Link className="shadow library-card bg-white" to="/library/equipment-providers">
        <FAIcon name="wheelchair" type="fas" className="library-card-icon d-inline-block align-middle text-primary" />
        <h5 className="mb-0 pl-3 d-inline-block align-middle">Durable Medical Equipment</h5>
      </Link>

      <Link className="shadow library-card bg-white" to="/library/pharmacies">
        <FAIcon name="pills" type="fas" className="library-card-icon d-inline-block align-middle text-primary" />
        <h5 className="mb-0 pl-3 d-inline-block align-middle">Pharmacies</h5>
      </Link>

      <Link className="shadow library-card bg-white" to="/library/ime-providers">
        <FAIcon name="stethoscope" type="fas" className="library-card-icon d-inline-block align-middle text-primary" />
        <h5 className="mb-0 pl-3 d-inline-block align-middle">IME Providers</h5>
      </Link>

      <Link className="shadow library-card bg-white" to="/library/clients">
        <FAIcon name="building" type="fas" className="library-card-icon d-inline-block align-middle text-primary" />
        <h5 className="mb-0 pl-3 d-inline-block align-middle">Clients</h5>
      </Link>

      <Link className="shadow library-card bg-white" to="/library/adjusters">
        <FAIcon name="user-tie" type="fas" className="library-card-icon d-inline-block align-middle text-primary" />
        <h5 className="mb-0 pl-3 d-inline-block align-middle">Claims Adjusters</h5>
      </Link>

      <Link className="shadow library-card bg-white" to="/library/translation-services">
        <FAIcon name="language" type="fas" className="library-card-icon d-inline-block align-middle text-primary" />
        <h5 className="mb-0 pl-3 d-inline-block align-middle">Translation Services</h5>
      </Link>

      <Link className="shadow library-card bg-white" to="/library/transportation-services">
        <FAIcon name="bus" type="fas" className="library-card-icon d-inline-block align-middle text-primary" />
        <h5 className="mb-0 pl-3 d-inline-block align-middle">Transportation Services</h5>
      </Link>

      {canManageCaseTypes && (
        <Link className="shadow library-card bg-white" to="/library/case-types">
          <FAIcon
            name="folder-open"
            type="fas"
            className="library-card-icon d-inline-block align-middle text-primary"
          />
          <h5 className="mb-0 pl-3 d-inline-block align-middle">Case Types</h5>
        </Link>
      )}

      <SmartLibraryReviewModal show={showSmartReview} onHide={() => setShowSmartReview(false)} />
    </div>
  )
})
